import { configureStore } from "@reduxjs/toolkit";

import rootReducer from "./rootReducer";
import { persistStore, persistReducer } from "redux-persist";
import thunk from "redux-thunk";
import { defaultAxios } from "../utils/axios/default.axios";
import { userAxios } from "../utils/axios/user.axios";
import storage from "redux-persist/lib/storage";
import { productAxios } from "../utils/axios/product.axios";
import { reportsAxios } from "../utils/axios/reports.axios";
import { analyticsAxios } from "../utils/axios/analytics";
import { aiAxios } from "../utils/axios/ai.axios";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: () => {
    let thunkWithParameters = thunk.withExtraArgument({
      apiService: {
        default: defaultAxios,
        user: userAxios,
        product: productAxios,
        reports: reportsAxios,
        analytics: analyticsAxios,
        ai:aiAxios
      },
    });
    return [thunkWithParameters];
  },
  devTools: process.env.NODE_ENV !== "production",
});

export const persistor = persistStore(store);
